module.exports = __webpack_public_path__ + "static/media/painter painting.ebb7d7ac.gif";